<template>

  <div class="container">
    <!-- <h2><center>Large Language Models (LLM) Projects</center></h2> -->
    <div class="home">
      <div class="nav">
        <a href="mailto:official.shriraang@gmail.com" class="mail"
          >Let's Connect</a
        >
      </div>
    </div>

    <div class="ATS">
      <a href="https://resume-ats.streamlit.app/" style="color: black">
        <img class="ats-img" src="../assets/ATS.png" alt="ATS Image" />
      </a>

      <div class="ats-content">
        <a
          href="https://resume-ats.streamlit.app/"
          style="text-decoration: none; color: black"
        >
          <h2 @click="Titleclicked">
            <b>Application Tracking System (ATS)</b>
          </h2>
        </a>

        <div class="description">
          <a
            href="https://shrirangsapate.netlify.app/"
            @click="ATSclicked"
            style="color: black"
            >Shrirang</a
          >
          has developed an innovative Applicant Tracking System (ATS) by
          seamlessly integrating Streamlit and Google's generative AI, Gemini.
          This cutting-edge system empowers you to have their resumes
          evaluated for relevance to specific job profiles. The process involves
          uploading a resume, and the system utilizes Google's
          advanced generative AI to analyze both the resume and the
          corresponding job description. The ATS provides tailored insights
          through two distinctive scenarios, Job profile matching and Percentage
          match Analysis
          <br /><br />

          <b>1. Job Profile Matching:</b>
          <li>
            The system generates insights on how well the resume aligns with the
            specified job profile, highlighting key strengths and potential
            areas for improvement.
          </li>
          <li>
            Users receive detailed feedback to enhance their resume's
            compatibility with the desired job.
          </li>
          <br />

          <b>2. Percentage Match Analysis: </b>
          <li>
            Upon resume submission, the ATS assesses the percentage match
            between the uploaded resume and the job description.
          </li>
          <li>
            The ATS evaluates the content, considering keywords, skills, and
            qualifications.
          </li>
          <li>
            Users receive a comprehensive percentage match analysis, indicating
            the level of alignment between their resume and the job
            requirements.
          </li>
          <li>
            This quantitative feedback assists users in gauging the suitability
            of their resume for the targeted position.
          </li>
          <br />

          <b>Why Use Our ATS? </b>
          <li>
            <b>Instant Insights:</b> Upload your resume and
            receive instant, personalized insights.
          </li>
          <li>
            <b>Tailored Feedback:</b> Our system, fueled by Google's generative
            AI, provides tailored feedback for Job Profile Matching and
            Percentage Match Analysis.
          </li>
          <li>
            <b>Maximize Opportunities:</b> Understand how well your resume
            aligns with specific job profiles, and optimize it to stand out from
            the competition.
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ATS",

  watch: {
    "$route.params.id": "loadAnswerComponent",
  },
  methods: {
    trackPageView(pagePath, pageTitle) {
      this.$gtag.pageview({
        page_path: pagePath,
        page_title: pageTitle,
      });
    },

    Titleclicked() {
      this.$gtag.event("question-visited", {
        event_category: "result-page",
        event_label: "question-clicked",
        value: 1,
      });
    },

    ATSclicked() {
      this.$gtag.event("question-visited", {
        event_category: "result-page",
        event_label: "question-clicked",
        value: 1,
      });
    },
  },
  created() {
    this.trackPageView("/", "LandingPage");
  },

  mounted() {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-79PXEFGWC7";
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-8JLWWR61M0");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  max-width: 2000px;
  margin: 0 auto;
  padding: 20px;
}

.home {
  display: flex;
  text-align: center;
  box-shadow: 0 5px 10px -7px rgba(0, 0, 0, 0.5);
  border-radius: 18px;
  max-height: 50px;
  font-family: "KoHo", sans-serif;
}

.nav {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  color: white;
  margin-left: 87.5rem;
  margin-bottom: 0.5rem;
  margin-top: -0.5rem;
}

.nav a {
  text-decoration: none;
  color: grey;
  margin: 5px 5px 5px -36px;
}

.nav a:hover {
  border-bottom: 2px solid grey;
}

.mail {
  margin: 5px;
}

h3 {
  font-weight: 500;
}

.description {
  text-align: justify;
}

.ATS {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}

.ats-content {
  margin-left: 0rem;
  margin-top: 0rem;
}

.ats-img {
  width: 45.36rem;
  height: 36rem;
  margin-top: 0rem;
  margin-left: 2rem;
  margin-right: 3rem;
  background-color: mintcream;
  border-radius: 50px;
  box-shadow: 0 5px 30px 0px rgba(0, 0, 0, 0.5);
}


/*Responsive Queries*/

@media (max-width: 1440px) {
  .nav {
    margin-top: -1rem;
  }
  .nav a {
    margin: 6px 5px 5px -123px;
  }

  .ats-img[data-v-c43b66c0] {
    width: 34.36rem;
    height: 28rem;
  }

  .ats-content{
    margin-right: 1rem;
    font-size: 15px;
  }
}

@media (max-width: 1024px) {
  .container {
    width: 1380px;
  }

  .ats-img {
    width: 45.36rem !important;
    height: 36rem !important;
  }

  .ats-content {
    font-size: 16.5px !important;
    margin-right:2rem;
  }

  .nav a {
    margin: 6px 5px 5px -157px;
    font-size: 19px;
  }
}

@media (max-width: 768px){

  .container {
    width: 1380px;
  }

  .ATS{
    display: flex;
    flex-direction: column;
  }

  .ats-img {
    width: 70.36rem !important;
    height: 55rem !important;
    margin-top: 1rem;
  }

  .ats-content {
    margin-top: 3rem;
    font-size: 30px !important;
    margin-left: 5rem;
    margin-right:5rem;
  }

  .nav a {
    margin: 18px 5px 5px -279px;
    font-size: 35px;
  }
}

@media only screen and (max-width: 425px) {
  .ATS{
    display: flex;
    flex-direction: column;
  }

  .ats-content {
    margin-top: 2rem;
    font-size: 40px !important;
    margin-left:5rem;
    margin-right: 5rem;
  }

  .ats-img {
    width: 74.36rem !important;
    height: 59rem !important;
    margin-top: 1rem;
  }
}

@media only screen and (max-width: 375px) {

  .container{
    width: 1240px;
  }

  .nav a {
    margin: 21px 5px 5px -410px;
    font-size: 34px;
  }
  .ATS{
    display: flex;
    flex-direction: column;
  }

  .ats-content {
    margin-top: 2rem;
    font-size: 42px !important;
    margin-left:5rem !important;
    margin-right: 5rem !important;
  }

  .ats-img {
    width: 66.36rem !important;
    height: 54rem !important;
    margin-top: 1rem;
  }
}

</style>
